<template>
    <aside class="faq-aside">
        <p>Если вы не нашли ответ на вопрос, задайте его через форму</p>
        <a href @click.prevent="handleClick" class="btn transparent full-width large js-open-popup"><span>Задать вопрос</span></a>
    </aside>
</template>

<script>
    import {mapMutations, mapActions} from 'vuex'

    import AskQuestionForm from "./AskQuestionForm"

    export default {
        name: 'ask-question',
        methods: {
            ...mapActions([
                'switchPopup'
            ]),
            ...mapMutations([
                'setPopupComponent',
            ]),
            handleClick() {
                this.setPopupComponent(AskQuestionForm);
                this.switchPopup(true);
            }
        }
    }
</script>


<style scoped>

</style>
